import { useEffect } from "react";

import { captureFirstTouch } from "~/feature/attribution/utils/firstTouchCookie";
import { readLandingVisit } from "~/feature/attribution/utils/readLandingVisit";

export const useCaptureFirstTouch = (): void => {
  useEffect(() => {
    captureFirstTouch(readLandingVisit(Date.now()));
  }, []);
};
